/* Mock-only actions: "Reset demo data" and forcing the session to expire. */
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import { authToken } from '@/api/token'
import { authKeys } from './auth'

export function useResetDemoData() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async () => {
      await api.post('/_mock/reset', {}, { anonymous: true })
      authToken.clear()
      qc.clear()
    },
  })
}

/** Expires the current session on the mock server, then refetches it so the re-login dialog opens here. */
export function useExpireSession() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => api.post('/_mock/expire-session'),
    onSuccess: () => qc.invalidateQueries({ queryKey: authKeys.session }),
  })
}
